import React from 'react';
import { getPermissionsForModule, Scopes } from 'src/app/scopes/scopes';

import Locations from './Children/Locations';

export const LocationsConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      id: 'locationsGroup',
      path: 'locations',
      scopes: getPermissionsForModule('Location'),
      children: [
        {
          scopes: [Scopes.Location.show],
          id: 'locationsGroup.main',
          path: '',
          element: <Locations />,
        },
        // {
        //   scopes: [Scopes.Location.store],
        //   id: 'locationsGroup.create',
        //   path: 'create',
        //   element: <Create />,
        // },
        // {
        //   scopes: [Scopes.Location.update],
        //   id: 'locationsGroup.update',
        //   path: 'update',
        //   element: <Update />,
        // },
      ],
    },
  ],
};
